package es.subastia.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import es.subastia.navigation.NavRoute
import es.subastia.navigation.Navigator
import org.jetbrains.compose.resources.stringResource
import es.subastia.ui.components.SubastiaButton
import org.jetbrains.compose.ui.tooling.preview.Preview
import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.btn_go_to_profile

@Composable
fun LoginRequiredPlaceholder(
    message: String,
    navigator: Navigator,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(24.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Text(
            text = message,
            style = MaterialTheme.typography.bodyLarge,
            textAlign = TextAlign.Center,
            color = MaterialTheme.colorScheme.onSurfaceVariant
        )
        
        Spacer(Modifier.height(24.dp))
        
        SubastiaButton(
            text = stringResource(Res.string.btn_go_to_profile),
            onClick = {
                navigator.navigateTo(NavRoute.Profile)
            }
        )
    }
}

@Preview
@Composable
fun LoginRequiredPlaceholderPreview() {
    MaterialTheme {
        LoginRequiredPlaceholder(
            message = "Please login to see your favorites",
            navigator = Navigator(),
        )
    }
}
